import { createGlobalStyle, css } from 'styled-components';

const Typography = createGlobalStyle`${css`
	#smooth-content {
		will-change: transform;
	}

	body {
		position: relative;
		width: 100%;
		min-height: 100vh;
		font-family: var(--montserrat_arm);
		font-weight: 400;
		line-height: var(--lineHeightS);
		background-color: var(--backgroundColor);
		color: var(--mainColor);
		overflow-x: hidden;
		overflow-y: ${(props) => (props.popupIsOpen || props.isBurgerMenuOpen ? 'hidden' : '')};

		main {
			position: relative;
			display: flex;
			flex-direction: column;
			min-height: 100vh;
			padding-top: calc(var(--headerFixedHeight) + var(--headerBannerHeight));
			overflow: hidden;
			z-index: 1;
		}

		&.no-hidden {
			main {
				overflow: unset !important;
			}
		}

		&.hidden {
			overflow: hidden !important;
			max-height: 100dvh !important;
		}

		/* //! For IOS */
		&.touch-action {
			* {
				touch-action: none;
				-ms-touch-action: none;
			}
		}

		/* //! For Cart Mobile */
		&.special-offers-block {
			* {
				touch-action: none;
				-ms-touch-action: none;
			}

			overflow: hidden !important;
			max-height: 100dvh !important;

			header {
				filter: blur(7px);
				pointer-events: none;
			}

			main {
				z-index: 9;
				pointer-events: none;

				&::before {
					content: '';
					width: 100vw;
					height: 100dvh;
					position: fixed;
					bottom: 0;
					left: 0;
					backdrop-filter: blur(7px);
					z-index: 9;
				}
			}
		}
	}

	//! Font sizes
	.h1,
	h1 {
		font-size: var(--h1);
		line-height: var(--lineHeightS);
		font-weight: inherit;
	}

	.h2,
	h2 {
		font-size: var(--h2);
		line-height: var(--lineHeightS);
		font-weight: inherit;
	}

	.h3,
	h3 {
		font-size: var(--h3);
		line-height: var(--lineHeightS);
		font-weight: inherit;
	}

	.h4,
	h4 {
		font-size: var(--h4);
		line-height: var(--lineHeightS);
		font-weight: inherit;
	}

	.h5,
	h5 {
		font-size: var(--h5);
		line-height: var(--lineHeightS);
		font-weight: inherit;
	}

	.h6,
	h6 {
		font-size: var(--h6);
		line-height: var(--lineHeightS);
		font-weight: inherit;
	}

	.p,
	p {
		font-size: var(--p);
		line-height: var(--lineHeight);

		--p: var(--p1);

		&.p1 {
			--p: var(--p1);
		}

		&.p2 {
			--p: var(--p2);
		}

		&.p3 {
			--p: var(--p3);
		}

		&.p4 {
			--p: var(--p4);
		}

		&.p5 {
			--p: var(--p5);
		}

		&.p6 {
			--p: var(--p6);
		}
	}
`}`;

export default Typography;
